import { Box, ButtonGroup } from "@mui/material"
import { Outlet, useLocation, useNavigate, useParams } from "@tanstack/react-router"
import type { FC } from "react"
import {
  PRODUCT_QUALITY_LAYOUT_ROUTE_PATH,
  getProductQualityTabRoute,
} from "routes/app/product/$productId/edit/_layout/quality/_layout"

import { ProductQualityTabPathname } from "./TestTemplates/types"

import { Button } from "@/components/common/Button"

export const QualityTabsLayout: FC = () => {
  const { productId } = useParams({ from: PRODUCT_QUALITY_LAYOUT_ROUTE_PATH })
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const tabClasses = "rounded-none border-gray-400 uppercase text-gray-700"

  const handleNavigateToTab = (tab: ProductQualityTabPathname) => {
    navigate({
      to: getProductQualityTabRoute(productId, tab),
    })
  }

  const isActiveTab = (tab: ProductQualityTabPathname) => {
    return pathname.endsWith(`/${tab}`)
  }

  const getActiveTabClass = (tab: ProductQualityTabPathname) => {
    return `${isActiveTab(tab) ? "bg-gray-300" : ""}`
  }

  return (
    <Box className='flex h-full flex-col gap-y-6'>
      <ButtonGroup
        color='inherit'
        orientation='horizontal'
        variant='outlined'
        className='shrink-0'
        data-testid='product-quality-button-group'
      >
        <Button
          appearance='outlined'
          className={`${tabClasses} rounded-l-md border-r-0 ${getActiveTabClass(ProductQualityTabPathname.Results)}`}
          onClick={() => handleNavigateToTab(ProductQualityTabPathname.Results)}
        >
          TEST RESULTS
        </Button>
        <Button
          appearance='outlined'
          className={`${tabClasses} rounded-r-md ${getActiveTabClass(ProductQualityTabPathname.Templates)}`}
          onClick={() => handleNavigateToTab(ProductQualityTabPathname.Templates)}
        >
          TEST TEMPLATE
        </Button>
      </ButtonGroup>
      <Box className='flex-1 overflow-auto'>
        <Outlet />
      </Box>
    </Box>
  )
}
